import _ from 'lodash';
import { sum } from '@/method'
import { numConvert, calculation } from '../../../../method';

export const correspond = ({ sumData = [], data, ...dataAll }) => {
    data = _.cloneDeep(data);
    const correspondIndex = {
        0: [3, 4],
        1: [5],
        2: [0, 2, 8],
        3: [1],
        4: [6],
        5: [7]
    };

    const correspondKey = {
        thisy_employee_num: {
            key: 'actual_count',
            value: "hr4_1_3"
        },
        thisy_average_payroll: {
            key: 'average_month',
            value: "hr4_1_3"
        },
        // lasty_employee_num: {
        //     key: 'actual_count',
        //     value: "hr4_1_3_last"
        // },
        // lasty_average_payroll: {
        //     key: 'average_month',
        //     value: "hr4_1_3_last"
        // },

        year_thisy_average_payroll: {
            key: 'average_date',
            value: "hr4_1_3"
        },
        year_thisy_payroll_cost: {
            key: 'training_date',
            value: "hr4_1_3"
        },
    };

    // 填充4.1.3数据
    Object.entries(correspondIndex).forEach(item => {
        Object.entries(correspondKey).forEach(_item => {
            // 阅读人均受训时间
            if (_item[0] == 'thisy_average_payroll') {
                data[item[0]][_item[0]] = calculation(
                    sum(item[1].map(x => {
                        return _.get(dataAll, `${_item[1].value}[${x}].training_month`, 0)
                    })),
                    sum(item[1].map(x => {
                        return _.get(dataAll, `${_item[1].value}[${x}].actual_count`, 0)
                    })),
                );
            }
            // 年度人均受训时间
            // if (_item[0] == 'year_thisy_average_payroll') {
            //     data[item[0]][_item[0]] = calculation(
            //         sum(item[1].map(x => {
            //             return _.get(dataAll, `${_item[1].value}[${x}].training_date`, 0)
            //         })),
            //         sum(item[1].map(x => {
            //             return _.get(dataAll, `${_item[1].value}[${x}].actual_count`, 0)
            //         })),
            //     );
            // }
            // 年度培训小时人次数
            if (_item[0] == 'year_thisy_payroll_cost') {
                data[item[0]][_item[0]] = sum(item[1].map(x => {
                    return _.get(dataAll, `${_item[1].value}[${x}].${_item[1].key}`, 0)
                }));
            }
            // 部门人数
            if (_item[0] == 'thisy_employee_num') {
                data[item[0]][_item[0]] = sum(item[1].map(x => {
                    return _.get(dataAll, `${_item[1].value}[${x}].${_item[1].key}`, 0)
                }));
            }


        });
    });

    // 填充年累计
    data.forEach((item, index) => {
        data[index].year_thisy_employee_num = (numConvert(_.get(sumData.find(x => x.name == item.name), 'thisy_employee_num', 0)) + numConvert(item['thisy_employee_num'])).toFixed(2);
        data[index].year_thisy_average_payroll = calculation(
            data[index].year_thisy_payroll_cost,
            data[index].year_thisy_employee_num
        );

        //    计算培训时间总计
        data[index].thisy_payroll_cost = (data[index].thisy_employee_num * data[index].thisy_average_payroll).toFixed(2);
        data[index].lasty_payroll_cost = (data[index].lasty_employee_num * data[index].lasty_average_payroll).toFixed(2);

    });

    return data

}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-4/compute.js